import React, { useMemo } from 'react';
import {
  buildCajasAgrupadas,
  filterCajasCatalogoPorSucursales,
} from '../../../utils/reportesCajasEmpresaModel';
import './ReportesFiltrosCajasEmpresa.css';

export default function ReportesFiltrosCajasEmpresa({
  sucursales = [],
  sucursalesTodas = true,
  sucursalesSeleccionadas = [],
  onSucursalesTodasChange,
  onSucursalCheckedChange,
  cajasTodas = true,
  permitirCajasTodas = true,
  cajasSeleccionadas = [],
  onCajasTodasChange,
  onCajaCheckedChange,
  cajasCatalogo = [],
  loading = false,
}) {
  const cajasCatalogoFiltrado = useMemo(
    () =>
      filterCajasCatalogoPorSucursales(cajasCatalogo, {
        sucursalesTodas,
        sucursalesSeleccionadas,
        sucursales,
      }),
    [cajasCatalogo, sucursales, sucursalesSeleccionadas, sucursalesTodas],
  );

  const cajasAgrupadas = useMemo(
    () =>
      buildCajasAgrupadas(cajasCatalogo, cajasCatalogoFiltrado, {
        sucursalesTodas,
        sucursalesSeleccionadas,
      }),
    [cajasCatalogo, cajasCatalogoFiltrado, sucursalesTodas, sucursalesSeleccionadas],
  );

  const cajasSeleccionadasSet = useMemo(
    () => new Set(cajasSeleccionadas.map((k) => String(k))),
    [cajasSeleccionadas],
  );

  const sucursalesSeleccionadasSet = useMemo(
    () => new Set(sucursalesSeleccionadas.map((id) => String(id))),
    [sucursalesSeleccionadas],
  );

  return (
    <div className="filtros-ce">
      <section className="filtros-ce__bloque filtros-ce__bloque--empresa">
        <h4 className="filtros-ce__titulo">SUCURSALES</h4>
        <ul className="filtros-ce__lista">
          <li>
            <label className="filtros-ce__opcion">
              <input
                type="checkbox"
                checked={sucursalesTodas}
                onChange={(e) => onSucursalesTodasChange?.(e.target.checked)}
              />
              <span>Todas</span>
            </label>
          </li>
          {sucursales.map((s) => {
            const id = String(s.sucursalId);
            const checked = sucursalesTodas || sucursalesSeleccionadasSet.has(id);
            return (
              <li key={id}>
                <label className={`filtros-ce__opcion${sucursalesTodas ? ' is-disabled' : ''}`}>
                  <input
                    type="checkbox"
                    checked={checked}
                    disabled={sucursalesTodas}
                    onChange={(e) => onSucursalCheckedChange?.(id, e.target.checked)}
                  />
                  <span>{s.nombreSucursal}</span>
                </label>
              </li>
            );
          })}
        </ul>
      </section>

      <section className="filtros-ce__bloque filtros-ce__bloque--cajas">
        <h4 className="filtros-ce__titulo">CAJAS</h4>
        {loading ? (
          <p className="filtros-ce__status">Cargando cajas…</p>
        ) : (
          <ul className="filtros-ce__lista">
            <li>
              <label className={`filtros-ce__opcion${!permitirCajasTodas ? ' is-disabled' : ''}`}>
                <input
                  type="checkbox"
                  checked={cajasTodas && permitirCajasTodas}
                  disabled={!permitirCajasTodas}
                  onChange={(e) => onCajasTodasChange?.(e.target.checked)}
                />
                <span>TODAS</span>
              </label>
            </li>
            {!permitirCajasTodas && (
              <li className="filtros-ce__nota">
                Selecciona al menos una sucursal para filtrar cajas.
              </li>
            )}
            {cajasAgrupadas.map((caja) => {
              const checked = cajasTodas || cajasSeleccionadasSet.has(caja.key);
              return (
                <li key={caja.key ?? caja.codigo}>
                  <label className={`filtros-ce__opcion${cajasTodas ? ' is-disabled' : ''}`}>
                    <input
                      type="checkbox"
                      checked={checked}
                      disabled={cajasTodas}
                      onChange={(e) => onCajaCheckedChange?.(caja.key, e.target.checked)}
                    />
                    <span className="filtros-ce__caja-label">{caja.label}</span>
                  </label>
                </li>
              );
            })}
          </ul>
        )}
      </section>
    </div>
  );
}
